import { render } from "./BankAccount1Ec.vue?vue&type=template&id=58a604af&scoped=true"
import script from "./BankAccount1Ec.vue?vue&type=script&lang=js"
export * from "./BankAccount1Ec.vue?vue&type=script&lang=js"

import "./BankAccount1Ec.vue?vue&type=style&index=0&id=58a604af&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a604af"]])

export default __exports__